import { Button, KIND, SIZE, SHAPE } from "baseui/button";
import { ButtonGroup } from 'baseui/button-group';
import { useNavigate } from "react-router-dom";
import { StatefulPopover, PLACEMENT } from "baseui/popover";
import { StatefulMenu } from "baseui/menu";
import { Block } from 'baseui/block';

import { IoIosStarOutline } from 'react-icons/io'
import { IoShareOutline, IoLogoAppleAr } from 'react-icons/io5'
import {
    useSnackbar,

} from 'baseui/snackbar';
import { Check, DeleteAlt } from 'baseui/icon';
import { useHasRole } from "../../hooks/useHasRole";
import { AccessRoles } from "../../hooks/useHasRole/accessRoles";
import { useGetDashboards } from "../../hooks/useGetDashboards";
import { IDashboardCollection } from "../../features/Dashboard/types";
import { useAddDashboardItem } from "../../hooks/useAddDashboardItem";
import { IAutomationObject } from "../types";
import { getBimId } from "../utils";

export type StatusPanelButtonsGroupProps = {
    app: IAutomationObject
}

export const StatusPanelButtonsGroup = (props: StatusPanelButtonsGroupProps) => {
    const navigate = useNavigate();
    const bimId = getBimId(props.app);

    function showBim() {
        
        navigate(`/bim/${bimId}`);
    }

    return (
        <Block justifyContent='flex-end' flexDirection='row' display='flex'>
            {/* <Button kind={KIND.secondary} size={SIZE.mini} shape={SHAPE.pill} onClick={showDetails}>Details</Button> */}
            <ButtonGroup kind={KIND.tertiary} size={SIZE.compact} shape={SHAPE.circle}>
                {bimId &&
                    <Button kind={KIND.secondary} size={SIZE.mini} shape={SHAPE.pill} onClick={(e) => { e.preventDefault(); showBim(); }}>
                        <IoLogoAppleAr />
                    </Button>
                }
                <FavoriteButton app={props.app} />


                <StatefulPopover placement={PLACEMENT.topLeft}
                    content={() => (
                        <StatefulMenu
                            items={[
                                { label: "Copy Link" },
                            ]}
                        />
                    )}
                    returnFocus
                    autoFocus
                >
                    <Button kind={KIND.tertiary} size={SIZE.compact} shape={SHAPE.circle}>
                        <IoShareOutline />
                    </Button>
                </StatefulPopover>

            </ButtonGroup>
        </Block>
    )
}


const FavoriteButton = (props: { app: IAutomationObject }) => {
    const hasAccessDashboard = useHasRole(AccessRoles.Dashboard.Write);
    return (
        <StatefulPopover  placement={PLACEMENT.topLeft}
            content={({ close }) => (
                <DashboardMenuItems  app={props.app} close={close}></DashboardMenuItems>
            )}
            returnFocus
            autoFocus
        >
            <Button disabled={!hasAccessDashboard} kind={KIND.tertiary} size={SIZE.compact} shape={SHAPE.circle}>
                <IoIosStarOutline ></IoIosStarOutline>
            </Button>
        </StatefulPopover>
    );
}

const DashboardMenuItems = (props: { app: IAutomationObject, close: () => void },) => {
    const { objects: data, error, isLoading, isSuccess } = useGetDashboards();
    const [add, result] = useAddDashboardItem()
    const { enqueue } = useSnackbar();

    function handleAddToDashboard( dashboard: IDashboardCollection, app: IAutomationObject) {
            add(dashboard,app);
            if (result.isSuccess) {
                enqueue({
                    message: 'added to Dashboard',
                    startEnhancer: ({ size }) => <Check size={size} />,
                })
            }
            else if (result.error) {
                enqueue({
                    message: 'Error add item to Dashboard',
                    startEnhancer: ({ size }) => <DeleteAlt size={size} />
                })
            }
    }

    return (
        <StatefulMenu
            items={data?.map((item: IDashboardCollection, index: number) => { return { label: item.name, id: item.id, element: item } }) || [ { label: 'loading ...', disabled: true}]}
            onItemSelect={(args) => { handleAddToDashboard(args.item.element,props.app); props.close(); }}
        />
    )
}